export default "__VITE_ASSET__BSIu9q4c__"